module.exports = __webpack_public_path__ + "img/WF_24_elasi_sm.f7272a68.jpg";